export enum ECodeType {
  LOGIN = "LOGIN",
  REGISTER = "REGISTER",
}
